import $ from 'jquery';
import moment from 'moment';

const defaults = {
  // Button text displayed as the pagination to the next page of events
  paginationLabel: 'Load More Events',
};

export default class CalendarList {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.buildCalendar();
  }

  buildCalendar() {
    const $posts = this.$element.find('.node');
    const group = '<div class="group"></div>';
    let currentYear = null;
    let currentMonth = '';
    let $group;

    // Manage the types of calendar filters being created
    $posts.each((i, post) => {
      const $post = $(post);
      const dates = ['start', 'end'];
      const oDates = {};

      // Remove the default 12:00am start time from displaying.
      const $eventDate = $post.find('header .event-date');
      if ($eventDate.text() === '12:00am') {
        $eventDate.addClass('hidden');
      }

      // Parse the start/end timestamps using the moment.js framework
      $.each(dates, (j, type) => {
        const datetime = $post.find(`time.${type}`).attr('datetime');
        const date = moment(datetime);
        oDates[type] = {
          month: date.format('MMMM'),
          mon: date.format('MMM'),
          day: date.format('D'),
          dow: date.format('ddd'),
          year: date.format('YYYY'),
        };
      });

      // Add the post into a month grouping
      if (oDates.start.month.length && currentMonth !== oDates.start.month) {
        currentMonth = oDates.start.month;
        $group = $(group);
        $group.addClass(oDates.start.month.toLowerCase());
        $group.append(`<h3 class="group-title">${oDates.start.month}</h3>`);
        $post.before($group);

        // Set year labels followed by the associated months of that year
        if (oDates.start.year && oDates.start.year > currentYear) {
          const $year = $(`<span class="group-year">${oDates.start.year}</span>`);
          $group.before($year);
          currentYear = oDates.start.year;
        }
      }

      // Dynamically create the date tile for the event display
      const $tile = $post.find('.event-date-tile');
      const markup = data => `<span class="day-of-week">${data.dow}</span><span class="month">${data.mon}</span><span class="day">${data.day}</span>`;
      $tile.find('time.start').html(markup(oDates.start));

      // Handle date ranges
      if ($tile.is('.range')) {
        const isSameMonth = oDates.start.month === oDates.end.month;
        const isSameDay = oDates.start.day === oDates.end.day;
        const isSameYear = oDates.start.year === oDates.end.year;

        // This identifies an event which begins and ends at different times on the same day
        if (isSameMonth && isSameDay && isSameYear) {
          $post.addClass('day-event');
        }

        // This identifies an event which spans multiple days within the same month
        if (isSameMonth && !isSameDay && isSameYear) {
          $post.addClass('multiple-day-event');
          $tile.find('time.start .day').text(`${oDates.start.day}-${oDates.end.day}`);
        }

        // This identifies an event which spans multiple months or maybe a year(s)
        if (!isSameMonth || !isSameYear) {
          $post.addClass('multiple-month-event');
          $tile.find('time.end').html(markup(oDates.end));
        }
      }

      // Add the grouped posts to the display
      $post.appendTo($group);
    });

    // Alter the text of the next pager button
    $('.pager-next a', this.$element).text(this.settings.paginationLabel);

    // Add a helper class
    this.$element.addClass('ready');
  }
}
